import React from 'react';
import { Link } from 'react-router';
import { Icon } from 'vx-ui-components';
import logo from '../../assets/img/logo-negative.svg';
import smallLogo from '../../assets/img/logo-negative2.svg';
import styles from './styles.css';

class SideBar extends React.Component {
  constructor(props) {
    super(props);

    // On start-up select the sidebar item based on the current pathname
    const selectedItem = this.findCurrentLocation();

    this.state = { selectedItem: selectedItem.slice(3) };

    this.findCurrentLocation = this.findCurrentLocation.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { menu, pathname } = this.props;

    if (prevProps.pathname !== pathname) {
      const currentLocation = this.findCurrentLocation();

      // Update selected item
      this.setState({ selectedItem: currentLocation.slice(3) });
      // Expand menu item
      const targetMenuItem = menu.find(item =>
        item.path === currentLocation ||
        item.child.find(child => child.path === currentLocation)
      );
      this.props.toggleChildrenMenu(targetMenuItem);
    }
  }

  findCurrentLocation() {
    const { pathname } = this.props;

    // Find the menu item that have to be expanded
    let targetPathname = pathname
    .split('/')                                             // split string by /
    .filter(item => !item.includes('-') && item !== 'add')  // filter items containing - (IDs in the form XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX)
    .join('/');                                             // join array back to a string by /

    return targetPathname.split('/').length > 4
      ? targetPathname.split('/').slice(0, -1).join('/')
      : targetPathname;
  }

  handleSectionClick(item) {
    this.props.toggleChildrenMenu(item);
  }

  render() {
    const { menu, open, toggle } = this.props;
    const { selectedItem } = this.state;

    return (
      <div className={`${styles.sidebar} ${!open ? styles.collapsed : ''}`}>
        <img
          src={open ? logo : smallLogo}
          className={`${open ? styles.logo : styles.smallLogo}`}
          alt="VXFiber"
        />
        {
          menu.map(item => (
            <div
              key={item.id}
              className={styles.section}
            >
              <div
                className={`
                  ${styles.titleWrapper}
                  ${item.id === selectedItem ? styles.selected : ''}
                  ${open && item.expand ? styles.selected : ''}
                `}
              >
                <Link
                  to={item.path}
                  className={styles.title}
                  onClick={() => { this.handleSectionClick(item); }}
                >
                  <Icon name={item.icon} stroke="#F2F2F2" strokeWidth="2" />
                  {
                    // Item names are shown only when the sidebar is completely open
                    open && <div>{item.name}</div>
                  }
                </Link>
                <div
                  className={`${styles.children} ${styles.submenu}`}
                  style={{ display: (open && item.expand) && 'none' }}
                >
                  {
                    (!open && item.child.length > 0) &&
                      <Link
                        to={item.path}
                        className={styles.title}
                        onClick={() => { this.handleSectionClick(item); }}
                      >
                        <div>{item.name}</div>
                      </Link>
                  }
                  {
                    item.child.map(subitem => (
                      <Link
                        key={subitem.id}
                        to={subitem.path}
                        className={`
                          ${styles.child}
                          ${subitem.id === selectedItem ? styles.selected : ''}
                        `}
                        onClick={() => { this.handleSectionClick(item); }}
                      >
                        {subitem.name}
                      </Link>
                    ))
                  }
                </div>
              </div>
              <div className={styles.children}>
                {
                  // Child-items are shown only when the sidebar is completely open
                  (open && item.expand) &&
                    item.child.map(subitem => (
                      <Link
                        key={subitem.id}
                        to={subitem.path}
                        className={`
                          ${styles.child}
                          ${subitem.id === selectedItem ? styles.selected : ''}
                        `}
                        onClick={() => { this.handleSectionClick(item); }}
                      >
                        {subitem.name}
                      </Link>
                    ))
                }
              </div>
            </div>
          ))
        }
        {
          open
            ? <div className={styles.collapseToggle} onClick={toggle}>
              <Icon name='back' stroke='#FFF'/>
              <Icon name='back' stroke='#FFF'/>
            </div>
            : <div className={styles.collapseToggle} onClick={toggle}>
              <Icon name='next' stroke='#FFF'/>
              <Icon name='next' stroke='#FFF'/>
            </div>
        }
      </div>
    );
  }
};

export default SideBar;



// WEBPACK FOOTER //
// ./src/components/SideBar/index.js